import React, { useEffect } from 'react';
import Projects from './Projects';

// Thin wrapper to mirror ContactPage pattern.
const ProjectsPage = () => {
    useEffect(() => {
        document.title = 'Projects — Kayleigh Schlupp';
    }, []);
    return <Projects isStandalone={true} />;
};

export default ProjectsPage;
